import i18next from 'i18next';
import ICU from 'i18next-icu';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';

import { getPageLang } from './utils';

const lang = getPageLang();

// NOTE: This is a promise
const instance = i18next
  .use(ICU)
  .use(HttpBackend)
  .init<HttpBackendOptions>({
  // if you're using a language detector, do not define the lng option
  // (we're not because we set it in the HTML lang attribute ourselves)
  lng: lang,
  fallbackLng: 'en',
  debug: true,
  partialBundledLanguages: true,
  ns: [],
  // resources: {},
  backend: {
    // for all available options read the backend's repository readme file
    loadPath: '/lang/{{lng}}/{{ns}}.json',
  },
});

// === Load the required translations on page load

// We need English as a fallback regardless of the user's language
const languagesToLoad = new Set(['en']);
// Add the user's language (in a set so not double loading English)
languagesToLoad.add(lang);
i18next.loadLanguages(Array.from(languagesToLoad));
console.debug('i18next Languages loaded:', languagesToLoad);

// TODO: Load anything we need on every page here
// We can load individual namespaces we need in the page/module files, so we don't pull in more than we need
// i18next.loadNamespaces(['general']);

export default instance;
